import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Alert } from 'antd';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var AlertContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"])));
export var RootAlert = function RootAlert(props) {
  var showIcon = props.showIcon,
      banner = props.banner,
      closable = props.closable;
  return /*#__PURE__*/_jsx(AlertContainer, {
    children: /*#__PURE__*/_jsx(Alert, _objectSpread(_objectSpread({}, props), {}, {
      showIcon: showIcon !== null && showIcon !== void 0 ? showIcon : true,
      banner: banner || false,
      closable: closable !== null && closable !== void 0 ? closable : false
    }))
  });
};